module.exports = __WEBPACK_EXTERNAL_MODULE_materials_normal_normalMaterial__;